import { useDashboardPermissions } from '@components'

import { useGetPaidDomainsQuery } from '../queries/useGetPaidDomainsQuery'

export const useCurrentDomain = () => {
  const { hasPermission } = useDashboardPermissions()

  const enabled = hasPermission('settings.domain')
  const { getPaidDomainsQuery } = useGetPaidDomainsQuery(undefined, {
    enabled,
  })

  const currentDomain = getPaidDomainsQuery.data?.[0] || null

  return {
    currentDomain,
    canClaimDomain: !currentDomain && enabled,
    isLoading: enabled && getPaidDomainsQuery.isLoading,
  }
}
